import './SectionHeader.css'
import {ISection} from "./model/B2CInfo";
import React from "react";

export interface ISectionHeaderProps {
    section: ISection
}

export default function SectionHeader(props: ISectionHeaderProps) {
    return <div className="Section_header">
        <div id={props.section.id} style={{marginTop: "-72px"}}/>
        <img className="SectionIcon" src={props.section.icon} alt={props.section.subtitle}/>
        <h2 style={{marginBottom: "8px"}}>{props.section.title}</h2>
        {props.section.subtitle != null && <h3>{props.section.subtitle}</h3>}
    </div>
}